<template>
<div>

  <div class="row">
    <div class="w-100 text-center mt-3">
      <h3>Products History</h3>
    </div>
    <div class="w-100 mt-3 mb-3 border-bottom border-danger">
      <div class="col-md-3 col-sm-4 d-md-inline-block mb-3">
        <b-form-input
          ref="ean"
          size="md"
          v-on:keyup.enter="getHistory"
          v-model="ean"
          placeholder="EAN code"
        ></b-form-input>
      </div>
      <div class="col-md-6 col-sm-4 d-md-inline-block mb-3">
        <b-button
          @click="getHistory"
          :class="!ean ? 'btn-outline-danger disabled' : 'btn-success'"
          size="md" style="margin-top: -5px; padding: 9px">
          <b-icon-search></b-icon-search>
        </b-button>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="w-100 position-relative" v-if="loading">
      <div class="w-100 mt-5 position-absolute text-center">
        <b-icon class="text-dark" icon="arrow-clockwise" animation="spin" font-scale="3"></b-icon>
      </div>
    </div>
    <div v-else-if="Object.keys(results).length" class="w-100 mt-3">
<!--      POLAND ORDERS HISTORY-->
      <div class="w-100" v-if="results.poland && results.poland.data">
        <h5 class="bg-primary w-auto p-1 rounded text-center">POLAND ORDERS</h5>
        <table class="table">
          <thead>
          <tr>
            <th scope="col">Meta Data</th>
            <th scope="col">SKU</th>
            <th scope="col" class="d-none d-sm-table-cell">Count</th>
            <th class="d-none d-sm-table-cell" scope="col">Added</th>
            <th scope="col">Transport</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(row, key) of results.poland.data" v-bind:key="key">
            <th scope="row">{{row.metaData}}</th>
            <td v-b-tooltip.hover.left="row.num">{{row.sku}}</td>
            <td class="d-none d-sm-table-cell">{{row.count}}</td>
            <td class="d-none d-sm-table-cell">{{moment(row.addedAt).format('DD.MM.yyyy')}}</td>
            <td class="d-sm-table-cell">{{transportStages(row.transport)}}</td>
          </tr>
          </tbody>
        </table>
      </div>
<!--      OUT HISTORY-->
      <div class="w-100" v-if="outOrders.length">
        <h5 class="bg-info w-auto p-1 rounded text-center">OUT</h5>
        <table class="table">
          <thead>
          <tr>
            <th scope="col">Meta Data</th>
            <th scope="col">SKU</th>
            <th scope="col" class="d-none d-sm-table-cell">Count</th>
            <th class="d-none d-sm-table-cell" scope="col">Added</th>
            <th scope="col">Transport</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(row, key) of outOrders" v-bind:key="key">
            <th scope="row">{{row.metaData}}</th>
            <td v-b-tooltip.hover.left="row.num">{{row.sku}}</td>
            <td class="d-none d-sm-table-cell">{{row.count}}</td>
            <td class="d-none d-sm-table-cell">{{moment(row.addedAt).format('DD.MM.yyyy')}}</td>
            <td class="d-sm-table-cell">{{transportStages(row.transport)}}</td>
          </tr>
          </tbody>
        </table>
      </div>
<!--      INVOICES HISTORY-->
      <div class="w-100" v-if="results.invoices && results.invoices.data">
        <h5 class="bg-success w-auto p-1 rounded text-center">INVOICES</h5>
        <table class="table">
          <thead>
          <tr>
            <th scope="col">Client</th>
            <th scope="col">SKU</th>
            <th scope="col">Name</th>
            <th scope="col" class="d-none d-sm-table-cell">Count</th>
            <th class="d-none d-sm-table-cell" scope="col">Added</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(row, key) of results.invoices.data" v-bind:key="key">
            <th scope="row">{{row.clientInfo.name}}</th>
            <td v-b-tooltip.hover.left="row.partNum">{{row.sku}}</td>
            <td class="d-none d-sm-table-cell">{{row.name}}</td>
            <td class="d-none d-sm-table-cell">{{row.qtt}}</td>
            <td class="d-sm-table-cell">{{moment(row.addedAt).format('DD.MM.yyyy')}}</td>
          </tr>
          </tbody>
        </table>
      </div>
<!--      REGOS HISTORY-->
      <div class="w-100" v-if="results.regos && results.regos.data">
        <h5 class="bg-warning w-auto p-1 rounded text-center text-dark">REGOS</h5>
        <table class="table">
          <thead>
          <tr>
            <th scope="col">Regos ID</th>
            <th scope="col" class="">SKU</th>
            <th scope="col" class="d-none d-sm-table-cell">Name</th>
            <th class="d-none d-sm-table-cell text-right" scope="col">Count</th>
            <th scope="col">Removed</th>
            <th class="d-none d-sm-table-cell" scope="col">Updated</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(row, key) of results.regos.data" v-bind:key="key">
            <th scope="row">{{row.regosId}}</th>
            <td>{{row.product.codename}}</td>
            <td class="d-none d-sm-table-cell">{{row.product.name}}</td>
            <td class="d-none d-sm-table-cell">{{row.count}}</td>
            <td class="d-sm-table-cell">{{row.removed}}</td>
            <td class="d-none d-sm-table-cell">{{moment(row.updatedAt).format('DD.MM.yyyy HH:mm:ss')}}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-else class="w-100">
      <h1 class="text-center"><b-icon-upc-scan></b-icon-upc-scan></h1>
    </div>
  </div>

</div>
</template>
<script lang="js">
import axios from 'axios';
import moment from 'moment';
import fixed from '@/fixed';

// Poland rows carrying one of these meta data values stay internal,
// everything else is considered as leaving the company.
const INTERNAL_META_DATA = ['WEB REPLACEMENT', 'WORKSHOP-AUTOMATION', 'WORKSHOP'];

export default {
  data: () => ({
    loading: false,
    ean: null,
    results: {},

    moment,
  }),
  computed: {
    outOrders() {
      const rows = (this.results.poland && this.results.poland.data) || [];
      return rows.filter((row) => !INTERNAL_META_DATA.includes(row.metaData));
    },
  },
  mounted() {
    this.$refs.ean.focus();
  },
  methods: {
    async getHistory() {
      if (!this.ean) return;

      this.loading = true;
      this.results = {};
      try {
        const { data } = await axios.get(
          `${fixed.API_URL}/admin/history?ean=${this.ean}`,
          { withCredentials: true },
        );
        this.results = data;
        this.ean = null;
      } catch (e) {
        this.$toast.error(e.response.data || 'Something went wrong');
      }
      this.loading = false;
    },
    transportStages(transport) {
      // Check if response exists and has transport property
      if (!transport || !Object.keys(transport).length) {
        return '';
      }

      const countries = [];

      // Add poland data if it exists
      if (transport.poland) {
        const polandDate = moment(transport.poland).format('DD.MM.yyyy');
        countries.push(`PL: ${polandDate}`);
      }

      // Add norway data if it exists
      if (transport.norway) {
        const norwayDate = moment(transport.norway).format('DD.MM.yyyy');
        countries.push(`NO: ${norwayDate}`);
      }

      // Join countries with comma or return empty string if none
      return countries.length ? countries.join('\n') : '';
    },
  },
};
</script>
